import React from "react";
import styles from "./Table.module.scss";

export interface TableProps {
  id: string;
  title: string;
  totalDocs?: number;
  pendingDocs?: number;
}

class Table extends React.Component<TableProps, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      width: window.innerWidth,
      responsive: false
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentWillMount() {
    if (this.state.width <= 576) {
      this.setState({responsive: true});
    }
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    });
    if (this.state.width <= 576) {
      this.setState({responsive: true});
    } else {
      this.setState({responsive: false});

    }
  }

  render() {

    let numberStyle;
    if (this.props.pendingDocs === this.props.totalDocs) {
      numberStyle = {color: "#0033a0", fontWeight: "bold", fontSize: "20px"};
    } else {
      numberStyle = {color: "#b50000", fontWeight: "bold", fontSize: "20px"};
    }

    return (
      <>
        <div className={styles.TableContainer}>
          <div className="container-fluid">
            <div className="row">
              <div className={styles.TitleContainer}>
                <div className="col-xl-6 col-md-6 col-sm-6 col-12">
                  <label className={styles.Title}>{this.props.title}</label>
                </div>
                <div className="col-xl-6 col-md-6 col-sm-6 col-12">
                  <label className={styles.LabelDocs}>
                    Documentos recibidos:
                    <div className={styles.NumDocs}>
                      <label style={numberStyle}>{this.props.pendingDocs}</label> / {this.props.totalDocs}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="container-fluid">
              {!this.state.responsive &&
              <>
                <div className={styles.Header}>
                  <div className="col-4">
                    <label className={styles.LabelBig}>DOCUMENTO</label>
                  </div>
                  <div className="col-4">
                    <label className={styles.LabelBig}>OBSERVACIONES</label>
                  </div>
                  <div className="col-2">
                    <label className={styles.LabelBig}>FECHA DE CARGA</label>
                  </div>
                  <div className="col-2">
                    <label className={styles.LabelBig}>ESTADO</label>
                  </div>
                </div>
                <div className={styles.InfoContainer}>
                  {this.props.children}
                </div>
              </>
              }
            </div>
          </div>
          {this.state.responsive &&
          <>
            {this.props.children}
          </>
          }
        </div>
      </>
    );
  }

}

export default Table;
